<template>
    <div>
        <vue-echarts :option="option" ref="chart" class="chart" autoResize />
    </div>
</template>

<script>
import { VueEcharts } from "vue3-echarts";
// import { computed, onMounted } from 'vue';

export default {
    name: 'doughnut',
    data() {
        return {
        }
    },
    props: {
        probSolution: Object
    },
    methods: {
        globalNumDecFixed(num, dec_amount) {
            var new_num = Number(num);
            if (!(num % 1)) {
                dec_amount = 0;
            }
            return new Intl.NumberFormat("en-US", {
                minimumFractionDigits: dec_amount,
            }).format(new_num.toFixed(dec_amount));
        },
        millionShortNum(num) {
            if (num >= 1000000000000000000000000) {
                return this.globalNumDecFixed(
                    (num / 1000000000000000000000000).toFixed(2).replace(/\.0$/, ""),
                    2
                );
            }
            if (num >= 1000000000000000000) {
                return this.globalNumDecFixed(
                    (num / 1000000000000000000).toFixed(2).replace(/\.0$/, ""),
                    2
                );
            }
            if (num >= 1000000000000) {
                return this.globalNumDecFixed((num / 1000000000000)
                    .toFixed(2)
                    .replace(/\.0$/, ""), 2);
            }
            if (num >= 1000000) {
                return this.globalNumDecFixed((num / 1000000)
                    .toFixed(2)
                    .replace(/\.0$/, ""), 2);
            }
            return this.globalNumDecFixed(num.toFixed(2).replace(/\.0$/, ""), 2);
        },
        millionShortString(num) {
            if (num >= 1000000000000000000000000) {
                return "ล้านล้านล้านล้าน";
            }
            if (num >= 1000000000000000000) {
                return "ล้านล้านล้าน";
            }
            if (num >= 1000000000000) {
                return "ล้านล้าน";
            }
            if (num >= 1000000) {
                return "ล้าน";
            }
            return '';
        }
    },
    components: {
        VueEcharts,
    },
    mounted() {
        setTimeout(function () {
            this.$nextTick(() => {
                if (this.$refs.chart) {
                    this.$refs.chart.setOption(this.option);
                }
            })
        }.bind(this), 350)
    },
    computed: {
        option() {
            return {
                tooltip: {
                    trigger: 'item',
                    confine: 'true',
                    textStyle: {
                        fontFamily: 'kanit',
                        fontWeight: '400',
                        color: '#1d4481'
                    },
                    backgroundColor: '#f3f6f9',
                    borderColor: 'none',
                    valueFormatter: (value) => this.globalNumDecFixed(value) + ' แผน'
                },
                legend: {
                    show: false,
                    top: 'center',
                    left: 'left',
                    orient: 'vertical',
                    icon: 'circle',
                    textStyle: {
                        color: '#728196'
                    },
                },
                textStyle: {
                    fontFamily: 'kanit',
                    fontWeight: 'normal'
                },
                series: [
                    {
                        name: {
                            show: false
                        },
                        type: 'pie',
                        radius: ['65%', '90%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderColor: '#fff',
                            borderWidth: 5,
                        },
                        label: {
                            show: true,
                            position: 'center',
                            formatter: '{c|' + this.millionShortNum(this.probSolution.suggestion + this.probSolution.assistance + this.probSolution.transfer) + '} {d|' + this.millionShortString(this.probSolution.suggestion + this.probSolution.assistance + this.probSolution.transfer) + '} \n\n แผนการให้ความช่วยเหลือ',
                            rich: {
                                c: {
                                    fontSize: 25,
                                    height: 25,
                                    verticalAlign: 'bottom',
                                    lineHeight: 15,
                                },
                                d: {
                                    fontSize: 15,
                                    height: 20,
                                    verticalAlign: 'bottom',
                                    lineHeight: 25,
                                }
                            },
                            textStyle: {
                                color: '#1d4481'
                            }
                        },
                        labelLine: {
                            show: true
                        },
                        color: ['#7bbae0', '#cdac7a', '#e1dfa6'],
                        data: [
                            { value: this.probSolution.suggestion, name: 'ให้คำแนะนำ' },
                            { value: this.probSolution.assistance, name: 'ช่วยเหลือโดย พม.' },
                            { value: this.probSolution.transfer, name: 'ประสานส่งต่อหน่วยงานอื่น' },
                        ]
                    }
                ]
            }
        },
    },
};
</script>

<style scoped>
.chart {
    top: 0px;
    max-height: 250px;
    height: 250px;
}

@media screen and (max-width: 1199.8px) {
    .chart {
        max-height: 230px;
        height: 230px;
    }
}
</style>